import { useReduxState } from "../../explorer/redux/hooks";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";

export const useApiPersistNotification: () => [string | undefined, (error: string | undefined) => void] = () => {
  const [persistNotification, setPersistNotification] = useReduxState<string | undefined>(reduxStoreConfig.systemApiPersistNotification);
  return [persistNotification, setPersistNotification];
};
